module.exports = __webpack_public_path__ + "static/shifting-gears-to-drive-09e52dc59b2e4843999b3cb55ac0f981.jpg";